import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/atoms/Card";
import { Skeleton } from "@/components/atoms/Skeleton";

const ApplicationCardSkeleton = () => {
  return (
    <Card className="group w-full max-sm:border-none">
      <CardHeader>
        <div className="w-full flex justify-between">
          <div className="flex gap-3">
            <Skeleton className="w-16 h-16 rounded-xl border" />
            <div className="flex flex-col gap-3">
              <Skeleton className="w-32 h-4 rounded-xl" />
              <Skeleton className="w-16 h-4 rounded-xl" />
            </div>
          </div>
          <Skeleton className="w-7 h-7 rounded-full" />
        </div>
      </CardHeader>
      <CardContent className="max-sm:pl-[92px] pb-6">
        <div className="flex flex-col gap-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 max-w-[250px]" />
        </div>
      </CardContent>
      <CardFooter className="w-full flex justify-between max-sm:pl-[92px]">
        <Skeleton className="w-12 h-4 rounded-xl" />
        <div className="flex gap-2 items-center">
          <div className="flex gap-1 items-center">
            <Skeleton className="w-4 h-4 rounded-full" />
            <Skeleton className="w-4 h-4 rounded-full" />
          </div>
          <Skeleton className="w-4 h-4 rounded-full" />
        </div>
      </CardFooter>
    </Card>
  );
};

export default ApplicationCardSkeleton;
